// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { FastTrackInformationService } from './service/information.service';

@Component({
    selector: 'fast-track-information',
    standalone: false,
    template: `
        <div class="fast-track-information">
            <div class="card panel-monsido-card mt-3">
                <div class="card-body py-1">
                    <div class="row align-items-stretch py-2">
                        <div class="col-18 fast-track-check-status" tabindex="0">
                            <div translate>Effect on overall compliance level</div>
                            <span class="font-size-1-5">
                                {{getSnippetCompliance()/100 | monNumber:'0.[00]%'}}
                            </span>
                        </div>
                        <div class="col-16 border-size-1 border-l border-light-grey fast-track-check-status d-flex align-items-center">
                            <div class="doughnut-pages">
                                <mon-chart-doughnut [options]="options"
                                                [data]="chartData"
                                                [labels]="labels"
                                                [colors]="colors">
                                </mon-chart-doughnut>
                            </div>
                            <div class="inline-block ml-2"  tabindex="0">
                                <div translate>Affected pages</div>
                                <span class="font-size-1-5">{{getAffectedPages()}}</span>
                            </div>
                        </div>
                        <div class="col-14 border-size-1 border-l border-light-grey fast-track-check-status d-flex align-justify-center flex-column"
                            tabindex="0">
                            <div translate>Failing checks</div>
                            <span class="font-size-1-5">{{getSnippetIssues()}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card panel-monsido-card">
                <div class="card-body py-3" tabindex="0">
                    <span translate>Snippet</span>
                    <div class="html-snippet my-2">
                        {{ getSnippetSourceCode() | monCharacterLimit:maxCharacters }}
                    </div>
                    <button type="button"
                            (click)="toggleCharacterLimit()"
                            *ngIf="maxCharacters !== null && getSnippetSourceCode().length > maxCharacters"
                            class="btn btn-border-radius btn-link"
                            [attr.aria-label]="'Show the full code snippet' | translate"
                            translate>
                        Show more
                    </button>
                    <button type="button"
                            (click)="toggleCharacterLimit()"
                            *ngIf="maxCharacters === null"
                            class="btn btn-border-radius btn-link"
                            [attr.aria-label]="'Show less of the code snippet' | translate"
                            translate>
                        Show less
                    </button>
                </div>
            </div>
        </div>
    `,
})
export class FastTrackInformationComponent implements OnInit {
    @Input() affectedPagesCount: any;
    @Input() snippet: any;
    @Input() chartData: any; // [errorCount, successCount]

    maxCharacters: any;
    labels: any;
    colors: any;
    options: any;

    private snippetCharacterLimit = 200;

    constructor (private fastTrackInformationService: FastTrackInformationService) {}

    ngOnInit () {
        this.maxCharacters = this.snippetCharacterLimit;
        this.labels = ['', ''];
        this.colors = ['#ce2e54', '#dcdcdc'];
        this.options = {
            cutoutPercentage: 70,
            tooltips: {
                enabled: false,
            },
        };
    }

    getAffectedPages (): any {
        return this.fastTrackInformationService.getAffectedPages(this.affectedPagesCount);
    }

    getSnippetCompliance (): any {
        return this.fastTrackInformationService.getSnippetCompliance(this.snippet);
    }

    getSnippetIssues (): any {
        return this.fastTrackInformationService.getSnippetIssues(this.snippet) || '';
    }

    getSnippetSourceCode (): any {
        return this.fastTrackInformationService.getSnippetSourceCode(this.snippet) || '';
    }

    toggleCharacterLimit (): void {
        if (this.maxCharacters > 0) {
            this.maxCharacters = null;
        } else {
            this.maxCharacters = this.snippetCharacterLimit;
        }
    }
}
